import { ref } from 'vue';

export const useDebounce = (
	callback: () => void | Promise<void>,
	delay: number
) => {
	const timeout = ref<number>();

	const debounced = () => {
		if (timeout.value) clearTimeout(timeout.value);
		timeout.value = setTimeout(async () => {
			await callback();
		}, delay);
	};

	return debounced;
};
